import type { GgaFreeSpinGameOption } from '../@types/casino';
import { useGgaFreeSpinBetLevels } from '../queries/casino';

const useGgaFreeSpinBetSelection = (game: GgaFreeSpinGameOption | undefined, betAmount: unknown) => {
  const isLevelGame = game?.freeSpinType?.trim().toLowerCase() === 'level';
  const betLevels = useGgaFreeSpinBetLevels(game?.id, { enabled: isLevelGame });
  const invalidLevel =
    isLevelGame &&
    (!betLevels.isSuccess || betLevels.isFetching || !betLevels.data?.some((level) => level.value === betAmount));

  return { isLevelGame, betLevels, invalidLevel };
};

export default useGgaFreeSpinBetSelection;
